/* b2s-header-split.js — split top-level menu into left/right around centered logo */
(function(){
  'use strict';

  function splitMenu(){
    const headers = document.querySelectorAll('.header, sticky-header .header');
    headers.forEach(header => {
      if (header.dataset.b2sSplit === '1') return;

      const navLeft = header.querySelector(':scope > nav.header__inline-menu, :scope > .header__inline-menu');
      const heading = header.querySelector(':scope > .header__heading');
      const icons = header.querySelector(':scope > .header__icons');
      if (!navLeft || !heading || !icons) return;

      const ul = navLeft.querySelector('ul.list-menu, ul');
      if (!ul) return;
      const topItems = Array.from(ul.children);
      if (topItems.length < 4) return;

      /* Split: first 3 stay left, remainder go right */
      const splitAt = Math.ceil(topItems.length / 2);
      const rightItems = topItems.slice(splitAt);
      if (rightItems.length === 0) return;

      /* Create the right nav (clone of left wrapper) */
      const navRight = navLeft.cloneNode(false);
      navRight.classList.add('header__inline-menu--right');
      navRight.setAttribute('data-b2s-right', '1');
      const rightUl = ul.cloneNode(false);
      navRight.appendChild(rightUl);
      rightItems.forEach(li => rightUl.appendChild(li));

      header.insertBefore(navRight, icons);
      header.dataset.b2sSplit = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', splitMenu);
  } else {
    splitMenu();
  }
  const obs = new MutationObserver(() => splitMenu());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
